import { cn } from "@heroui/react";
import type { InboxAvatarTone } from "../data/types";

const toneClass: Record<InboxAvatarTone, string> = {
  primary: "bg-[#006FEE]",
  success: "bg-success",
  danger: "bg-danger",
  secondary: "bg-secondary",
  warning: "bg-warning",
  cyan: "bg-cyan-600",
  default: "bg-default-100 border border-default-200",
};

type DemoAvatarProps = {
  name: string;
  src?: string;
  initial?: string;
  tone?: InboxAvatarTone;
  size?: "sm" | "md";
};

export default function DemoAvatar({
  name,
  src,
  initial,
  tone = "primary",
  size = "md",
}: DemoAvatarProps) {
  const letter = (initial || name).trim().slice(0, 1) || "?";
  const dimension = size === "sm" ? "h-8 w-8 text-sm" : "h-9 w-9 text-[18px]";

  if (src) {
    return (
      <img
        alt=""
        className={cn("shrink-0 rounded-full object-cover", dimension)}
        src={src}
      />
    );
  }

  return (
    <span
      aria-hidden
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full font-normal leading-none",
        tone === "default" ? "text-default-700" : "text-white",
        dimension,
        toneClass[tone],
      )}
    >
      {letter}
    </span>
  );
}
